module.exports = __webpack_public_path__ + "img/Surgery.77a6d35a.svg";